"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmpRadioButton = void 0;
var react_1 = require("react");
function AmpRadioButton(props) {
    var value = props.value, name = props.name, id = props.id, ariaLabel = props.ariaLabel, children = props.children, _a = props.options, options = _a === void 0 ? {} : _a, selected = props.selected;
    var ampSelected = selected ? { selected: true } : {};
    var aria = ariaLabel ? { 'aria-label': ariaLabel } : {};
    var option = value ? { option: value } : {};
    var buttonClasses = ' butn pad-l-xxs pad-r-xxs flex';
    buttonClasses += options.buttonClasses ? ' ' + options.buttonClasses : '';
    buttonClasses += children ? '' : ' justify-center flex-items-center';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", __assign({}, option, ampSelected, { className: "radio-button-skin mar-t-xs " + buttonClasses, id: id, name: name, value: value }, aria), children),
        react_1.default.createElement("style", null, "\n        .radio-button-skin{\n          min-width: " + (options.fullWidth ? '100%' : ' 74px') + ";\n          font-size: 14px;\n          cursor: pointer;\n          color: #000;\n          height: auto;\n          min-height: 48px;\n          border: 1px solid #686e74;\n          border-radius: 3px;\n          background: transparent;\n          " + (options.fullWidth ? 'justify-content: left;' : '') + "\n        }\n      ")));
}
exports.AmpRadioButton = AmpRadioButton;
//# sourceMappingURL=AmpRadioButton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/RadioGroup/AmpRadioButton.js
// module id = 2380
// module chunks = 8